import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_Discussion = {
    _v1: {
        createNewDiscussion: { method: HttpMethod.POST, path: '/v1/discussions/create-new-discussion' },
        deleteDiscussion: { method: HttpMethod.POST, path: '/v1/discussions/delete-discussion' },
    }
};
//# sourceMappingURL=api-def.js.map